

export class ReminderUserGroupOutput implements IReminderUserGroupOutput {
    /** The auto-generated id of the user reminder master */
    reminder_user_id!: number;
    /** The auto-generated id of the user master */
    user_id!: number;

    constructor(data?: IReminderUserGroupOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminder_user_id = _data["reminder_user_id"];
            this.user_id = _data["user_id"];
        }
    }

    static fromJS(data: any): ReminderUserGroupOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderUserGroupOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminder_user_id"] = this.reminder_user_id;
        data["user_id"] = this.user_id;
        return data; 
    }
}

export interface IReminderUserGroupOutput {
    /** The auto-generated id of the user reminder master */
    reminder_user_id: number;
    /** The auto-generated id of the user master */
    user_id: number;
}

